import { LinkedContextState } from '@context/LinkedItemZoneContext'
import { BackAcabadosInfo } from '@utils/conversion/getStandardMaterial'

export default function handleTextureClick(texture: BackAcabadosInfo, context: LinkedContextState) {
  return { texture, context }
}
